import { SectionAPI } from "../views/Sections/types";

export const sortSections = (sections: any[], sortBy: string, sortDirection: string) => {
  if (!sortBy) return sections;
  const sortedSections = [...sections];
  sortedSections.sort((a, b) => {
    const aValue = a[sortBy as keyof SectionAPI];
    const bValue = b[sortBy as keyof SectionAPI];
    return aValue - bValue;
  });
  if (sortDirection === 'desc') sortedSections.reverse();
  return sortedSections;
};
